<cat-compare-desktop
  class="h-full hidden md:block"
  [first]="first$ | async"
  [second]="second$ | async"
></cat-compare-desktop>

<cat-compare-mobile
  class="h-full block md:hidden"
  [first]="first$ | async"
  [second]="second$ | async"
  (action)="onViewDetail($event)"
></cat-compare-mobile>
